import React from "react";
import { SmileOutlined } from "@ant-design/icons";
import helperSession from "../../js/helpers/helpersSession";
import InventoriesLog from "./admin/InventoriesLog/InventoriesLog";

const Home = () => {
  const nombre = helperSession.GetAccount("nombre");
  const isAdmin = helperSession.GetAccount("rol") === "Admin";
  const isSupervisor = helperSession.GetAccount("rol") === "Supervisor";

  const fechaActual = new Date().toLocaleString("es-CL", {
    dateStyle: "full",
    timeStyle: "short",
  });

  return (
    <div style={{ padding: "0 24px" }}>
      <div style={{ marginBottom: 24 }}>
        <h2 style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <SmileOutlined style={{ color: "#1890ff" }} />
          Bienvenido, {nombre}
        </h2>

        {(isAdmin || isSupervisor) && (
          <>
            <p style={{ margin: 0, color: "#666" }}>
              Este es un resumen en tiempo real de los movimientos recientes en productos.
            </p>
            <p style={{ marginTop: 4, color: "#999", fontSize: 13 }}>
              Última actualización: {fechaActual}
            </p>
          </>
        )}
      </div>

      {isAdmin && <InventoriesLog />}
    </div>
  );
};

export default Home;
